module.exports = __webpack_public_path__ + "img/arrow-left-circle.659f3e79.svg";